// extracted by mini-css-extract-plugin
module.exports = {"Container":"RemixBadge_Container__e6Zwy"};